import { useEffect, useMemo, useState } from "react";
import { DomShell } from "./_gameKit";
import AdReward from "./_adReward";

const EMOJI = ["⚡","🔥","🌊","🌙","⭐","🌈","🎯","💎"];

function shuffle(a) { return a.map((x) => [Math.random(), x]).sort((a, b) => a[0] - b[0]).map((x) => x[1]); }

export default function JixxeoMemoryFlip() {
  const [round, setRound] = useState(0);
  const cards = useMemo(() => shuffle([...EMOJI, ...EMOJI]).map((v, i) => ({ i, v, flipped: false, matched: false })), [round]);
  const [state, setState] = useState(cards);
  const [pick, setPick] = useState([]);
  const [moves, setMoves] = useState(0);
  const [start, setStart] = useState(0);
  const [elapsed, setElapsed] = useState(0);
  const [best, setBest] = useState(() => Number(localStorage.getItem("jixxeo_memory_best") || 0));
  const done = state.length > 0 && state.every((c) => c.matched);

  useEffect(() => { setState(cards); setPick([]); setMoves(0); setStart(Date.now()); }, [cards]);

  useEffect(() => {
    if (done) return;
    const t = setInterval(() => setElapsed(Math.floor((Date.now() - start) / 1000)), 200);
    return () => clearInterval(t);
  }, [start, done]);

  useEffect(() => {
    if (!done) return;
    const secs = Math.floor((Date.now() - start) / 1000);
    if (!best || secs < best) { setBest(secs); localStorage.setItem("jixxeo_memory_best", String(secs)); }
  }, [done, start, best]);

  const flip = (i) => {
    if (pick.length >= 2) return;
    if (state[i].flipped || state[i].matched) return;
    const ns = state.map((c) => c.i === i ? { ...c, flipped: true } : c);
    setState(ns);
    const np = [...pick, i];
    setPick(np);
    if (np.length === 2) {
      setMoves((m) => m + 1);
      const [a, b] = np;
      if (ns[a].v === ns[b].v) {
        setTimeout(() => {
          setState((s) => s.map((c) => (c.i === a || c.i === b) ? { ...c, matched: true } : c));
          setPick([]);
        }, 350);
      } else {
        setTimeout(() => {
          setState((s) => s.map((c) => (c.i === a || c.i === b) ? { ...c, flipped: false } : c));
          setPick([]);
        }, 800);
      }
    }
  };

  return (
    <DomShell title="Jixxeo Memory Flip" accent="#FFE300"
      chips={[["Time", `${elapsed}s`], ["Moves", moves], ["Best", best ? `${best}s` : "—"]]}
      instructions="Flip two cards. Match them all as fast as possible."
    >
      <div className="grid grid-cols-4 gap-2">
        {state.map((c) => (
          <button key={c.i} onClick={() => flip(c.i)}
            className="aspect-square rounded-xl border flex items-center justify-center text-2xl font-black transition-all"
            style={{
              background: c.matched ? "rgba(57,255,20,0.2)" : c.flipped ? "rgba(0,240,255,0.15)" : "rgba(255,255,255,0.04)",
              borderColor: c.matched ? "#39FF14" : c.flipped ? "#00F0FF" : "rgba(255,255,255,0.12)",
              transform: c.flipped || c.matched ? "rotateY(0deg)" : "rotateY(180deg)",
              opacity: c.matched ? 0.75 : 1,
            }}>
            {(c.flipped || c.matched) ? c.v : ""}
          </button>
        ))}
      </div>
      {done && (
        <div className="text-center mt-4 space-y-3">
          <div className="font-heading font-black text-2xl uppercase tracking-tighter text-[#FFE300]">Cleared in {elapsed}s</div>
          <div className="flex justify-center"><AdReward game="jixxeo-memory-flip" compact /></div>
          <button onClick={() => setRound((r) => r + 1)}
            className="mono text-[10px] uppercase tracking-widest bg-white/10 hover:bg-white/20 text-white font-black px-5 py-2 rounded-full">
            New game
          </button>
        </div>
      )}
    </DomShell>
  );
}
